<template>
    <div class='demo-app'>
        <div class='demo-app-main'>
            <!-- Spinner mientras se cargan los datos -->
            <div v-if="isLoading" class="spinner-overlay">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando datos...</span>
                </div>
            </div>
            <FullCalendar class='demo-app-calendar' :options='calendarOptions'>
                <template v-slot:eventContent='arg'>
                    <div v-if="arg.event.extendedProps.isVacaciones" class="event-icon">
                        <i class="fa-regular fa-sun"></i> <!-- Font Awesome sol -->
                    </div>
                    <i>&nbsp;&nbsp;{{ arg.event.title }}</i> <!-- Aquí se muestra el nombre del usuario -->
                </template>
            </FullCalendar>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import esLocale from '@fullcalendar/core/locales/es';

export default defineComponent({
    components: {
        FullCalendar,
    },
    data() {
        return {
            isLoading: true,
            calendarOptions: {
                plugins: [
                    dayGridPlugin,
                    interactionPlugin
                ],
                headerToolbar: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth'
                },
                locale: esLocale,
                initialView: 'dayGridMonth',
                events: [],
                editable: false,
                selectable: false,
                dayMaxEvents: true,
            },
        }
    },
    methods: {
        async fetchVacaciones() {
            const API_URL = import.meta.env.VITE_DJANGO_URL;
            const endpoint = `/api-imputacion-horas/vacaciones-personal`;
            console.log(`${API_URL}${endpoint}`);
            try {
                const response = await fetch(`${API_URL}${endpoint}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const vacaciones = await response.json();
                this.populateCalendarEventsVacaciones(vacaciones);
                this.isLoading = false;
            } catch (error) {
                console.error('Error fetching vacaciones:', error);
            }
        },
        populateCalendarEventsVacaciones(vacaciones) {
            const events = vacaciones.map(vacacion => ({
                title: vacacion.usuario, // Cambiamos "Vacaciones" por el nombre del usuario
                start: vacacion.fecha,
                allDay: false,
                classNames: ['vacaciones'],
                extendedProps: {
                    isVacaciones: true,
                }
            }));

            this.calendarOptions.events = events;
        },
    },
    mounted() {
        this.fetchVacaciones();
    }
})
</script>

<style lang='css'>
.spinner-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.vacaciones {
    background-color: rgb(25, 0, 255) !important;
    border-color: rgb(25, 0, 255) !important;
    color: white !important;
    font-size: 0.7em; /* Ajusta el tamaño de la fuente */
    padding: 2px 4px; /* Reduce el padding del evento */
    margin: 1px 0; /* Reduce el margen entre eventos */
    height: auto; /* Permite que la altura se ajuste automáticamente */
    line-height: 1.2; /* Ajusta la altura de la línea para hacer el texto más compacto */
    overflow: hidden; /* Esconde el contenido que sobrepasa */
    white-space: nowrap; /* Evita el salto de línea */
    text-overflow: ellipsis; /* Muestra "..." si el texto es demasiado largo */
}

.fc-event-title {
    font-size: 0.7em; /* Reduce aún más el tamaño del texto */
    padding: 0; /* Elimina padding dentro del texto del evento */
    line-height: 1.2; /* Ajusta la altura de la línea para compactar el contenido */
}

.fc-daygrid-event {
    min-height: 10px; /* Reduce la altura mínima de los eventos */
}


</style>
